// src/pages/PeladaDetails.js
import React, { useCallback, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "../components/Menu";
import PeladaDetalhes from "../components/PeladaDetalhes";
import ListaJogadores from "../components/ListaJogadores";
import "./PeladaDetails.css";

const PeladaDetails = () => {
  const { peladaId: groupId } = useParams();
  const navigate = useNavigate();
  const [loadingCount, setLoadingCount] = useState(0);

  // evita re-render loops quando filhos usam esses callbacks em effects
  const onStartLoading = useCallback(() => {
    setLoadingCount((prev) => prev + 1);
  }, []);
  const onFinishLoading = useCallback(() => {
    setLoadingCount((prev) => Math.max(prev - 1, 0));
  }, []);

  const loading = loadingCount > 0;

  return (
    <div className="pd-page">
      {/* Header fixo seguindo o padrão do app */}
      <div className="topbar">
        <Menu />
      </div>

      {loading && (
        <div className="loader-overlay">
          <div className="loader-spinner"></div>
          <p className="loader-text">Aguarde, carregando...</p>
        </div>
      )}

      <main className="pd-content" aria-busy={loading}>
        {/* cabeçalho da página */}
        <header className="pd-head">
          <div>
            <h1 className="pd-title">Detalhes da Pelada</h1>
            <p className="pd-subtitle">Informações da sessão e lista de jogadores</p>
          </div>
          <div className="pd-actions">
            <button className="btn btn--ghost" onClick={() => navigate(-1)}>⬅ Voltar</button>
          </div>
        </header>

        {/* grid responsiva: detalhes + lista */}
        <section className="pd-grid">
          <div className="pd-card">
            <div className="pd-card-head">
              <h2>Informações da Sessão</h2>
            </div>
            <div className="pd-card-body">
              {/* Dica: dentro do componente, use as classes utilitárias definidas no CSS abaixo */}
              <PeladaDetalhes
                peladaId={groupId}
                onStartLoading={onStartLoading}
                onFinishLoading={onFinishLoading}
              />
            </div>
          </div>

          <div className="pd-card">
            <div className="pd-card-head">
              <h2>Lista de Jogadores</h2>
            </div>
            <div className="pd-card-body">
              <ListaJogadores
                peladaId={groupId}
                onStartLoading={onStartLoading}
                onFinishLoading={onFinishLoading}
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PeladaDetails;
